angular
    .module('annexaApp')
        .controller('InteroperableDocumentTypeController',['$scope', '$rootScope', 'AnnexaFormlyFactory', 'AnnexaModalFactory', 'CommonAdminModals', 'HeaderService', '$state', 'TableFilter', 'DTColumnBuilder', '$filter', 'RestService', 'Language', 'HelperService', 'ErrorFactory','AdminFactory', 'DialogsFactory', 'GlobalDataFactory', 'TramNewFactory', 'CustomFieldFactory', '$q', '$http',
            function($scope, $rootScope, AnnexaFormlyFactory, AnnexaModalFactory, CommonAdminModals, HeaderService, $state, TableFilter, DTColumnBuilder, $filter, RestService, Language, HelperService, ErrorFactory, AdminFactory, DialogsFactory, GlobalDataFactory, TramNewFactory, CustomFieldFactory, $q, $http) {
                $scope.showLoadingdiv = false;
                $scope.languageColumn = Language.getActiveColumn();
                $scope.tfilter = new TableFilter();
                $scope.tfilter.addElement($scope.languageColumn, 'text', 1, 'global.literals.name');
                
                $scope.filter = [
                	{ id: Language.getActiveColumn(), type: 'text', order: 1, label: 'global.literals.name' },
                	{ id: 'interoperableCode', type: 'text', order: 2, label: 'global.interoperableDocumentType.interoperableCode'}
    			]
                $scope.additionalColumns = [
                	{ id: 'interoperableCode', title: $filter('translate')('global.interoperableDocumentType.interoperableCode'), sortable: true}
                ]
                
                $scope.newEmgdeDocumentType = angular.copy(CommonAdminModals.emgdeDocumentTypeNew);
                
                $scope.newElement = function () {
                    var modal = undefined;
                    modal = angular.copy($scope.newEmgdeDocumentType);
                    modal.title = 'global.interoperableDocumentType.titleNew';
                    modal.annexaFormly.model = {};
                    modal.annexaFormly.model.modal_body = {};
                    modal.annexaFormly.options = {};
                    AnnexaFormlyFactory.showModal('modalNewEmgdeDocumentType', modal, $scope.saveEmgdeDocumentType, false);
                };
                
                $scope.saveEmgdeDocumentType = function(){
        	 		if (this.annexaFormly.form.$valid) {
                    	var self = this;
                    	var data = this.annexaFormly.model.modal_body;
                    	var sendData = {
                    		interoperableCode:((data && data.interoperableCode)?data.interoperableCode:undefined),
                    		language1:((data && data.language1)?data.language1:'NotTranslated'),
                			language2:((data && data.language2)?data.language2:'NotTranslated'),
                			language3:((data && data.language3)?data.language3:'NotTranslated')
                    	}
                    	if(!sendData.interoperableCode){
                    		self.alerts.length = 0;
                    		self.alerts.push({ msg: $filter('translate')('global.interoperableDocumentType.interoperableCodeRequired') });
    	                }else{
	                        RestService.insert('./api/doc/emgde_document_type', sendData).then(function (dataGet) {
	                        	$rootScope.$broadcast('annexaAdminBaseReloadTable');
	                        	self.close();
	                        }).catch(function (error) {
	                        	self.alerts.length = 0;
                        		self.alerts.push({ msg: $filter('translate')('global.errors.unknownNew') });
	                        });
                    	}
                    }
                };
                
                $scope.viewElement = function (id) {
                    if(id) {
                    	var promises = [];
                        promises.push(RestService.findOne('EmgdeDocumentType', id));
                        $q.all(promises).then(function(data) {
                        	var modal = angular.copy(CommonAdminModals.emgdeDocumentTypeEdit);
                            modal.alerts = [];
                            modal.data = JSOG.decode(data[0].data);
							modal.languageColumn = Language.getActiveColumn();
							modal.updateEmgdeDocumentType = $scope.updateEmgdeDocumentType;
                            $scope.modelEmgdeDocumentTypeTemplate = modal;
							AnnexaModalFactory.showModal('modalEmgdeDocumentTypeEdit', modal);
                        });
                    }
                };
        	   
                $scope.updateEmgdeDocumentType = function(val, prop) {
            		var self = this;
                	var data = this.data;
                	var sendData = angular.copy(data);
                	var isValid = true;
                	if(prop === 'interoperableCode'){
                		if(!val){
                    		self.alerts.length = 0;
                    		self.alerts.push({ msg: $filter('translate')('global.interoperableDocumentType.interoperableCodeRequired') });
                    		isValid = false;
                		}else{
                			sendData.interoperableCode = val;
                		}
                	}
                	if(isValid){
	                	RestService.update('./api/doc/emgde_document_type/' + sendData.id, sendData).then(function() {
	                        $rootScope.$broadcast('annexaAdminBaseReloadTable');
	                    }).catch(function (error) {
	                    	self.alerts.length = 0;
                    		self.alerts.push({ msg: $filter('translate')('global.errors.unknownUpdate') });
	                    });
                	}
                };
    }]);